import io from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_API_URL;
const orgName = sessionStorage.getItem('organizationName');
const adminId = sessionStorage.getItem(`${orgName}_adminId`);
const organizationId = sessionStorage.getItem(`${orgName}_organizationId`);
const adminType = 'admin'; // 'admin' or 'superadmin'

export const socket = io(SOCKET_URL, {
  autoConnect: true,
  reconnection: true
});

const clearSessionAndRedirect = (reason) => {
  const orgName = sessionStorage.getItem('organizationName');
  if (orgName) {
    sessionStorage.removeItem(`${orgName}_token`);
    sessionStorage.removeItem(`${orgName}_adminId`);
    sessionStorage.removeItem(`${orgName}_organizationId`);
    sessionStorage.removeItem(`${orgName}_role`);
    sessionStorage.removeItem(`${orgName}_features`);
  }
  sessionStorage.removeItem('organizationName');
  socket.disconnect();
  // Redirect to login with a reason message so Login.jsx can display it
  const msg = encodeURIComponent(reason || 'You have been logged out.');
  window.location.href = `/login?reason=${msg}`;
};

export const initiateSocket = () => {
  if(!socket.connected) {
    socket.connect();
  }

  socket.on("connect", () => {
    if(adminId){
      console.log(`Connected to socket server with adminId: ${adminId}`);
      socket.emit("register", { userId: adminId, userType: adminType, organizationId: organizationId });
    } else {
      console.log(`Connected to socket server without adminId`);
    }
  });

  socket.on('chatAssigned', (data) => {
    console.log('Chat assigned event received:', data);
  });

  socket.on("disconnect", () => {
    console.log("Disconnected from socket server");
  });
  
  socket.on('userStatus', (data) => {
    console.log('User status received:', data);
  });

  socket.on('onlineUsers', (userId) => {
    console.log("Online users:", userId);
  });

  // Fired when the super-admin blocks this org's admin, or when org features change.
  // Clear all session data and send the user back to the login page immediately.
  socket.on('forceLogout', (data) => {
    console.warn('forceLogout received:', data?.reason);
    clearSessionAndRedirect(data?.reason);
  });

  socket.on("connect_error", (error) => {
    console.error("Connection error:", error);
  });

  socket.on("reconnect_attempt", () => {
    console.log("Reconnecting.....");
  });

  socket.on("reconnect", () => {
    console.log("Reconnected to server. Re-registering admin...");
    socket.emit("register", { userId: adminId, userType: adminType });
  });
};

export const registerAdmin = () => {
  const orgName = sessionStorage.getItem('organizationName');
  const currentAdminId = sessionStorage.getItem(`${orgName}_adminId`);
  if (currentAdminId && socket.connected) {
    console.log(`Registering admin with ID: ${currentAdminId}`);
    socket.emit("register", { userId: currentAdminId, userType: adminType, organizationId: sessionStorage.getItem(`${orgName}_organizationId`) });
  }
};

